var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"id":"myModal"}},[_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v("Убедитесь что программа NCALayer запущена и повторите попытку.")]),_c('button',{staticClass:"close"},[_vm._v("Хорошо")])])])
}]

export { render, staticRenderFns }